import React, { useState, useEffect } from "react";
import {FaArrowTrendUp,FaArrowTrendDown } from "react-icons/fa6";
import server, { endpoints } from "../../utils/server";
import "./style/tutoringTeamCardStyle.css";

const TutoringTeamCard = ({data}) => {

  return (
 <div className="card-wrapper">
      <div className="stats-card">
        <div className="background-text">{data.total}</div>

        <h2 className="card-title">{data.titulo}</h2>

        <div className="stat-row total-row">
          <span className="stat-label">Totales</span>
          <span className="stat-value-large">{data.total}</span>
        </div>

        <hr className="divider" />

        <div className="stat-row">
          <span className="stat-label">Mensual</span>
          <span className="stat-value">
            {data.mensual}{' '}
            {data.tendenciaMensual === 'up' && <FaArrowTrendUp className="trend-icon trend-up" />}
            {data.tendenciaMensual === 'down' && <FaArrowTrendDown className="trend-icon trend-down" />}
          </span>
        </div>
      </div>
    </div>
  ); 
};

export default TutoringTeamCard;